import { TableHead, styled } from '@mui/material';

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& > .MuiTableRow-root': {
    borderBottom:`1px solid ${theme.palette.grey[400]}`,
  },

  '& :first-child': {
    borderTop: 'none'
  },
}));
